/**
 * ContentRepository module
 *
 * This module create shortcut with a request
 * to the API
 *
 */

'use strict';

const RequestHandler = require('./../../../../../core/requestHandler');

const baseType = 'mailchimp';

module.exports.getInformation = function() {
    let dfd;
    let currentApiUrl = RequestHandler.getBaseUrl();

    RequestHandler.setBaseUrl('/api');
    dfd = RequestHandler.read(baseType + '/get-information');
    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.getToken = function(code) {
    let dfd;
    let currentApiUrl = RequestHandler.getBaseUrl();

    RequestHandler.setBaseUrl('/api');
    dfd = RequestHandler.read(baseType + '/get-token/' + code);
    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.getLists = function(token, dc) {
    let dfd;
    let currentApiUrl = RequestHandler.getBaseUrl();

    RequestHandler.setBaseUrl('/api');
    dfd = RequestHandler.read(baseType + '/lists/' + token, {'dc': dc});
    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};
